(function() {
  'use strict';

  angular
    .module('betosyswebapp')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('logout', {
        parent: 'app',
        url: '/logout',
        views: {
          'content@app': {
            controller: 'LogoutController'

          }
        },
        resolve: {
          $title: function () {
            return 'Logout';
          }
        }
      });
  }

})();



// WEBPACK FOOTER //
// ./.tmp/components/login/logout.route.js